// extracted by css-extract-rspack-plugin
export default {"groups-selected":"FzA4PB","groupsSelected":"FzA4PB"};